// extracted by mini-css-extract-plugin
module.exports = {"label":"ArchivedContestLabel_label__4_gje"};